import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import DashboardRoleTableService from '../service/DashboardRoleTableService';

const config = {
	key: 'dashboardRoleTable',
	topic: 'user',
	service: DashboardRoleTableService,
	editFormState: item => `/dashboard-role/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'title',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'adminDescription',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'isEnabled',
			type: 'boolean',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'created',
			type: 'dateTime',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'updated',
			type: 'dateTime',
			sortable: true,
			disablePadding: false
		}
	]
};

function DashboardRoleTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('dashboardRoleTable', reducer('dashboardRoleTable'))(DashboardRoleTable);
